module.exports = __webpack_public_path__ + "static/media/15.2a82bec1.jpg";